import { useEffect } from 'react';

var KEY_ENTER = 13;
var KEY_ESC = 27;
var KEY_UP = 38;
var KEY_DOWN = 40;
var KEY_TAB = 9;
var alphanum = /^[a-z0-9åäö]$/i;
var debounce;
var useTypeahead = function useTypeahead(element, value, setValue, maxKeyDelay) {
  if (maxKeyDelay === void 0) {
    maxKeyDelay = 1000;
  }
  useEffect(function () {
    if (element !== null) {
      var setSearchString = function setSearchString(char) {
        setValue(value + char);
        clearTimeout(debounce);
        debounce = setTimeout(function () {
          return setValue("");
        }, maxKeyDelay);
      };
      var onKeyDown = function onKeyDown(event) {
        /**
          * Don"t do anything if a modifier key is pressed. shift is
          * excluded from this list since users may capitalize their
          * text when typing to get to an option.
         **/
        if (event.metaKey || event.ctrlKey || event.altKey) {
          return;
        }
        if (![KEY_ENTER, KEY_ESC, KEY_UP, KEY_DOWN, KEY_TAB].includes(event.which)) {
          event.preventDefault();
          event.stopPropagation();
        }
        if (alphanum.test(String.fromCharCode(event.which))) {
          setSearchString(String.fromCharCode(event.which));
        }
      };
      element.addEventListener("keydown", onKeyDown);
      return function () {
        return element.removeEventListener("keydown", onKeyDown);
      };
    }
  }, [element, maxKeyDelay, value, setValue]);
};

export default useTypeahead;
export { KEY_DOWN, KEY_ENTER, KEY_ESC, KEY_TAB, KEY_UP, alphanum };
//# sourceMappingURL=use-typeahead.js.map
